import React from 'react';

import BookButton from './BookButton/BookButton';
import Aux from '../../../hoc/Auxiliary';
import classes from './BookButtons.module.css';

const bookButtons = (props) => {
    let dropDown = [classes.DropDown, classes.Hide].join(' ');
    if (props.bookShow) {
        dropDown = [classes.DropDown, classes.Show].join(' ')
    }

    const hamburgerClass = ['material-icons', classes.Toggle].join(' ');

    return (
        <Aux>
            <ul className={classes.BookButtons}>
                <BookButton link='/equipment'>Book Equipment</BookButton>
                <BookButton link='/class'>Book Class</BookButton>
            </ul>
            <ul className={classes.NarrowScreen}>
                <i className={hamburgerClass} onClick={props.bookShowToggle}>reorder</i>
                <div className={dropDown}>
                    <BookButton link='/equipment'>Book Equipment</BookButton>
                    <BookButton link='/class'>Book Class</BookButton>
                </div>
            </ul>
        </Aux>
    );
}
export default bookButtons;